import React, { useEffect, useState } from 'react'
import { uid } from '@zera-admin/utils'
import Breadcrumb, { BreadcrumbItem } from '@zera-admin/breadcrumb'
import Button, { ButtonGroup, LinkButton } from '@zera-admin/button'
import Page, { PageHeader, Container } from '@zera-admin/page'

import { useFlagcardContext } from 'app/contexts/flagcard'
import { ValidationError } from 'app/shared/types'
import MainLayout from 'layouts/main'
import namedEntityRecognitionsService, {
  NamedEntityRecognition,
  UpdateNamedEntityRecognitionRequest,
} from 'services/http/dataset/named-entity-recognition'

import { UpdateNamedEntityRecognitionProps } from './types'
import NamedEntityRecognitionForm from './NamedEntityRecognitionForm'

const UpdateNamedEntityRecognition: React.FunctionComponent<UpdateNamedEntityRecognitionProps> =
  ({ match, history }) => {
    const [isLoading, setIsLoading] = useState(false)
    const [isReady, setIsReady] = useState(true)
    const [namedEntityRecognition, setNamedEntityRecognition] =
      useState<NamedEntityRecognition>()
    const [flagcard] = useFlagcardContext()

    useEffect(() => {
      const id = parseInt(match.params.id)

      namedEntityRecognitionsService
        .getById(id)
        .then((res) => {
          setNamedEntityRecognition(res.data)
        })
        .catch((err: Error) => {
          console.log(err)
        })
        .finally(() => {
          setIsReady(false)
        })
    }, [match.params.id, history])

    const handleSubmit = (data: UpdateNamedEntityRecognitionRequest) => {
      if (data) {
        setIsLoading(true)

        namedEntityRecognitionsService
          .update(data)
          .then(() => {
            flagcard.add({
              id: uid(),
              appearance: 'success',
              title: 'İşlem Başarılı',
              children:
                'Geçerli veri, sistem üzerinde başarıyla güncellenmiştir.',
            })
          })
          .catch((error) => {
            console.log(error)

            flagcard.add({
              id: uid(),
              appearance: 'error',
              title: 'Hata Oluştu',
              children:
                'Geçerli veri güncellenirken bir hata oluştu. Lütfen tekrar deneyin. Sorununuz düzelmediyse servis sağlayıcısı ile iletişime geçiniz.',
            })
          })
          .finally(() => {
            setIsLoading(false)
          })
      }
    }

    const handleError = (error?: ValidationError) => {
      console.log(error)
    }

    const breadcrumbs = (
      <Breadcrumb>
        <BreadcrumbItem text="Anasayfa" href="/" />
        <BreadcrumbItem
          text="İsimlendirilmiş varlık tanıma"
          href="/named-entity-recognition"
        />
        <BreadcrumbItem text="İsimlendirilmiş varlık tanıma seti güncelle" />
      </Breadcrumb>
    )

    return (
      <MainLayout isLoading={isReady}>
        <Container width="medium">
          <Page>
            <PageHeader
              // actions={<Button appearance="error">Delete user</Button>}
              breadcrumbs={breadcrumbs}
              bottomBar={
                <p>
                  Aşağıdaki bilgileri doldurarak geçerli isimlendirilmiş varlık
                  tanıma setini güncelleyebilirsiniz.
                </p>
              }
            >
              Veri güncelleniyor:
              {namedEntityRecognition ? namedEntityRecognition.text : null}
            </PageHeader>
            <NamedEntityRecognitionForm
              actions={
                <ButtonGroup>
                  <Button
                    appearance="primary"
                    children="Güncelle"
                    isLoading={isLoading}
                    type="submit"
                  />
                  <LinkButton href="/named-entity-recognition">
                    İptal
                  </LinkButton>
                </ButtonGroup>
              }
              operation="update"
              onSubmit={handleSubmit}
              onError={handleError}
              values={namedEntityRecognition}
            />
          </Page>
        </Container>
      </MainLayout>
    )
  }

export default UpdateNamedEntityRecognition
